import { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { TrackingHOC } from 'hocs'
import LaunchPad from 'components/LaunchPad'
import { selectUser } from '../App/selectors'
import { selectLinksFetching, selectLinks, selectUserLinks } from './selectors'
import {
  fetchAdminLinks,
  addUserLink,
  fetchUserLinks,
  deleteUserLink,
  updateUserLink
} from './actions'

const LaunchPadContainer = ({
  fetchAdminLinks,
  fetchUserLinks,
  addUserLink,
  user,
  updateUserLink,
  deleteUserLink,
  createEvent,
  adminLinks,
  userLinks,
  isFetching,
  height
}) => {
  const [addLink, setAddLink] = useState(false)

  useEffect(() => {
    fetchAdminLinks()
    fetchUserLinks(user.name)
  }, [])

  const toggleAddForm = () => {
    setAddLink(!addLink)
  }
  const postLink = (link) => {
    addUserLink({ link, user: user.name })
    toggleAddForm()
  }

  const updateLink = (updatedLink) => {
    updateUserLink({ link: updatedLink, user: user.name })
  }

  const deleteLink = (id) => {
    deleteUserLink({ id, user: user.name })
  }

  const registerLinkClick = (e) => {
    createEvent({
      category: 'links',
      data: {
        action: 'LaunchPadLinkClicked',
        linkClicked: e.target.href
      }
    })
  }

  const generateProps = () => ({
    adminLinks,
    userLinks,
    isFetching,
    height,
    addLink,
    postLink,
    updateLink,
    deleteLink,
    toggleAddForm,
    registerLinkClick
  })

  return <LaunchPad {...generateProps()} />
}

const mapStateToProps = (state) => ({
  isFetching: selectLinksFetching(state),
  adminLinks: selectLinks(state),
  user: selectUser(state),
  userLinks: selectUserLinks(state)
})

const mapDispatchToProps = (dispatch) => ({
  fetchAdminLinks: () => dispatch(fetchAdminLinks.request()),
  addUserLink: (user) => dispatch(addUserLink.request(user)),
  fetchUserLinks: (data) => dispatch(fetchUserLinks.request(data)),
  deleteUserLink: (data) => dispatch(deleteUserLink.request(data)),
  updateUserLink: (data) => dispatch(updateUserLink.request(data))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TrackingHOC(LaunchPadContainer))
